import createClient, { type Middleware } from 'openapi-fetch';

import { API_HOST } from 'src/shared/constants';

import type { paths } from './schema';

import { toast } from 'src/shared/utils/app-toast';

import { deleteToken, getToken } from 'src/logic/services/token.service';

const client: ReturnType<typeof createClient<paths>> = createClient<paths>({
  baseUrl: API_HOST,
});

const httpInterceptor: Middleware = {
  onRequest: async ({ request }) => {
    const token = getToken();
    if (token) {
      request.headers.set('Authorization', 'Bearer ' + token);
    }
    return request;
  },
  // onResponse: async ({ response }) => {
  //   if (!response.ok) {
  //     const errorResponse = await response.json();
  //     const detail = errorResponse.detail;
  //
  //     if (detail === 'Unauthorized') {
  //       deleteToken();
  //       window.location.reload();
  //     }
  //
  //     toast.error(detail);
  //     return new Response(JSON.stringify(errorResponse), {
  //       status: response.status,
  //       statusText: response.statusText,
  //       headers: response.headers,
  //     });
  //   }
  //   return response;
  // },
  onResponse: async ({ response }) => {
    if (!response.ok) {
      let errorResponse: any = null;
      let detail = 'Request failed';

      const ct = response.headers.get('content-type') || '';
      if (ct.includes('application/json')) {
        errorResponse = await response.json();
        detail = errorResponse?.detail ?? detail;
      } else {
        const text = await response.text();
        detail = text || detail;
        errorResponse = { detail };
      }

      if (detail === 'Unauthorized') {
        deleteToken();
        window.location.reload();
      }

      toast.error(detail);

      return new Response(JSON.stringify(errorResponse), {
        status: response.status,
        statusText: response.statusText,
        headers: response.headers,
      });
    }
    return response;
  },
};

client.use(httpInterceptor);

export const apiClient = client;
